import _ from 'underscore';
import { get } from '@bingads-webui-universal/primitive-utilities';
import * as segmentationType from './segmentation-type';

const typeWithSameTexts = {
  [segmentationType.DayOfWeek]: segmentationType.DayOfTheWeek,
  [segmentationType.HourOfDay]: segmentationType.HourOfTheDay,
  [segmentationType.Device]: segmentationType.DeviceType,
};

const keys = {
  None: 'Segment_Dropdown_None',
  Time: 'Segment_Dropdown_Time',
  [segmentationType.Day]: 'Segment_Dropdown_Day',
  [segmentationType.Week]: 'Segment_Dropdown_Week',
  [segmentationType.Month]: 'Segment_Dropdown_Month',
  [segmentationType.Quarter]: 'Segment_Dropdown_Quarter',
  [segmentationType.Year]: 'Segment_Dropdown_Year',
  [segmentationType.DayOfTheWeek]: 'Segment_Dropdown_Day_Of_Week',
  [segmentationType.HourOfTheDay]: 'Segment_Dropdown_Hour_Of_Day',
  Audience: 'Segment_Dropdown_Audience',
  [segmentationType.AudienceName]: 'Segment_Dropdown_Audience_Name',
  [segmentationType.AudienceType]: 'Segment_Dropdown_Audience_Category',
  Goal: 'Segment_Dropdown_Conversions',
  [segmentationType.GoalName]: 'Segment_Dropdown_Goal_Name',
  [segmentationType.GoalType]: 'Segment_Dropdown_Goal_Type',
  [segmentationType.GoalCategory]: 'Segment_Dropdown_Goal_Category',
  [segmentationType.DeviceType]: 'Segment_Dropdown_Device_Type',
  [segmentationType.Network]: 'Segment_Dropdown_Network',
  [segmentationType.TopVsOther]: 'Segment_Dropdown_Top_Other',
  [segmentationType.AdScenario]: 'Segment_Dropdown_Ad_Scenario',
};

const valueKeys = {
  DayOfTheWeek: {
    Sunday: 'WeekDay_1',
    Monday: 'WeekDay_2',
    Tuesday: 'WeekDay_3',
    Wednesday: 'WeekDay_4',
    Thursday: 'WeekDay_5',
    Friday: 'WeekDay_6',
    Saturday: 'WeekDay_7',
  },

  DeviceType: {
    Unknown: 'Segment_Device_Type_Unknown',
    Computer: 'Segment_Device_Type_Computer',
    PC: 'Segment_Device_Type_Computer',
    SmartPhone: 'Segment_Device_Type_Smartphone',
    NonsmartPhone: 'Segment_Device_Type_NonSmartphone',
    Tablet: 'Segment_Device_Type_Tablet',
    ConnectedTV: 'Segment_Device_Type_ConnectedTV',
  },

  Network: {
    Unknown: 'Segment_Network_Unknown',
    BingAndYahooSearch: 'Segment_Network_BingAndYahoo',
    MicrosoftSitesAndSelectTraffic: 'Segment_Network_MicrosoftSitesAndSelectTraffic',
    SyndicatedSearchPartners: 'Segment_Network_SyndicatedSearch',
    AOLSearch: 'Segment_Network_AOL',
    InHouse: 'Segment_Network_InHouse',
    Content: 'Segment_Network_Content',
    Audience: 'Segment_Network_Audience',
    CrossNetwork: 'Segment_Network_CrossNetwork',
  },

  TopVsOther: {
    Unknown: 'Segment_Page_Position_Unknown',
    BingAndYahooSearchTop: 'Segment_Page_Position_BingYahooTop',
    BingAndYahooSearchOther: 'Segment_Page_Position_BingYahooOther',
    SyndicatedSearchPartnersTop: 'Segment_Page_Position_SyndicatedTop',
    SyndicatedSearchPartnersOther: 'Segment_Page_Position_SyndicatedOther',
    AOLSearchTop: 'Segment_Page_Position_AOL_Top',
    AOLSearchOther: 'Segment_Page_Position_AOL_Other',
    ContentNetwork: 'Segment_Page_Position_Content',
    AudienceNetwork: 'Segment_Page_Position_Audience_Network',
    MicrosoftSitesAndSelectTrafficTop: 'Segment_Page_Position_MicrosoftSitesAndSelectTrafficTop',
    MicrosoftSitesAndSelectTrafficOther: 'Segment_Page_Position_MicrosoftSitesAndSelectTrafficOther',
    CrossNetwork: 'Segment_Page_Position_CrossNetwork',
    InHouseTop: 'Segment_Page_Position_InHouseTop',
    InHouseOther: 'Segment_Page_Position_InHouseOther',
  },

  GoalType: {
    DestinationURL: 'UnifiedEventTracking_Goals_DestinationGoal',
    Duration: 'UnifiedEventTracking_Goals_DurationGoal',
    PageVisit: 'UnifiedEventTracking_Goals_PageViewsPerVisitGoal',
    Custom: 'UnifiedEventTracking_Goals_EventGoal',
    AppInstall: 'UnifiedEventTracking_Goals_ApplicationInstallGoal',
    MultiStage: 'UnifiedEventTracking_Goals_MultiStageGoal',
    OfflineConversion: 'UnifiedEventTracking_Goals_OfflineConversionGoal',
    InStoreTransaction: 'UnifiedEventTracking_Goals_InStoreTransactionGoal',
    HotelBooking: 'UnifiedEventTracking_Goals_HotelBookingGoal',
  },

  AudienceType: {
    RemarketingList: 'Segment_Audience_RemarketingList',
    InMarket: 'Segment_Audience_InMarket',
    Custom: 'Segment_Audience_Custom',
    SimilarToRemarketingList: 'Segment_Audience_SimilarToRemarketingList',
    Product: 'Segment_Audience_Product',
    CustomerList: 'Segment_Audience_CustomerList',
    CombinedList: 'Segment_Audience_CombinedList',
    PredictiveTargeting: 'Segment_Audience_PredictiveTargeting',
    ContextualTargeting: 'Segment_Audience_ContextualTargeting',
    ImpressionBasedRemarketingList: 'Segment_Audience_ImpressionBasedRemarketingList',
    UsersNotInAudienceSegments: 'Segment_Audience_UsersNotInAudienceSegments',
  },

  GoalCategory: {
    AddToCart: 'Segment_Goal_Category_AddToCart',
    BeginCheckout: 'Segment_Goal_Category_BeginCheckout',
    BookAppointment: 'Segment_Goal_Category_BookAppointment',
    Contact: 'Segment_Goal_Category_Contact',
    Download: 'Segment_Goal_Category_Download',
    GetDirections: 'Segment_Goal_Category_GetDirections',
    InStoreVisit: 'Segment_Goal_Category_InStoreVisit',
    Other: 'Segment_Goal_Category_Other',
    OutboundClick: 'Segment_Goal_Category_OutboundClick',
    PageView: 'Segment_Goal_Category_PageView',
    Purchase: 'Segment_Goal_Category_Purchase',
    RequestQuote: 'Segment_Goal_Category_RequestQuote',
    SignUp: 'Segment_Goal_Category_SignUp',
    SubmitLeadForm: 'Segment_Goal_Category_SubmitLeadForm',
    Subscribe: 'Segment_Goal_Category_Subscribe',
    Unassigned: 'Segment_Goal_Category_Unassigned',
  },

  [segmentationType.AdScenario]: {
    AutoAd: 'Segment_AdScenario_AutoAd',
    CreditCardAd: 'Segment_AdScenario_CreditCardAd',
    Other: 'Segment_AdScenario_Other',
    TourActivityAd: 'Segment_AdScenario_TourActivityAd',
    HealthInsuranceAd: 'Segment_AdScenario_HealthInsuranceAd',
    InsuranceServiceAd: 'Segment_AdScenario_InsuranceServiceAd',
    CruiseAd: 'Segment_AdScenario_CruiseAd',
    RealEstateServiceAd: 'Segment_AdScenario_RealEstateServiceAd',
    FinancialAdvisorAd: 'Segment_AdScenario_FinancialAdvisorAd',
    TaxServiceAd: 'Segment_AdScenario_TaxServiceAd',
    DoctorClinicAd: 'Segment_AdScenario_DoctorClinicAd',
    MortgageLenderAd: 'Segment_AdScenario_MortgageLenderAd',
    DebitCardAd: 'Segment_AdScenario_DebitCardAd',
    HomeServiceAd: 'Segment_AdScenario_HomeServiceAd',
    JobListingAd: 'Segment_AdScenario_JobListingAd',
    LegalServiceAd: 'Segment_AdScenario_LegalServiceAd',
  },
};

_.each(typeWithSameTexts, (defined, notDefined) => {
  keys[notDefined] = keys[defined];
  valueKeys[notDefined] = valueKeys[defined];
});

export function localizeSegmentationType({
  i18n,
  type,
}) {
  return i18n.getString(keys[type]);
}

export function localizeSegmentationValue({
  i18n,
  type,
  value,
}) {
  if (_.contains([
    segmentationType.HourOfTheDay,
    segmentationType.HourOfDay,
  ], type)) {
    const hour = parseInt(value, 10);

    if (hour === 0) {
      return i18n.getString('ImprovedAdScheduling_12AM_Start_Of_Day');
    }

    return i18n.getString(`ImprovedAdScheduling_${hour > 12 ? hour - 12 : hour}${hour < 12 ? 'AM' : 'PM'}`);
  } else if (_.contains([
    segmentationType.AudienceName,
    segmentationType.GoalName,
  ], type) || _.isNaN(Date.parse(value))) {
    const key = get(valueKeys, [type, value]);

    const localized = key ? i18n.getString(key) : value;

    if (type === segmentationType.AudienceName && localized === 'Users not in audience segments') {
      return i18n.getString('Segment_Audience_NoUser');
    }

    return localized;
  } else if (type !== segmentationType.Year) {
    const localized = i18n.formatDate(new Date(value), {
      timeZone: 'UTC',
      skeleton: 'yMd',
    });

    if (type === segmentationType.Week) {
      return i18n.getString('Segment_Week_Of_Date', { date: localized });
    }

    return localized;
  }

  return value;
}
